<template>
    <div >
        <div style="width: 100%;background-color:#FFFFFF;height:calc(100vh);z-index:1">
            <div style="text-align:center;padding-top:20px;padding-bottom:10px"><img src="@/assets/images/login-head.png" style="width:200px"></div>
            <div style="text-align:center">
                <div style="padding-top:20px;color:#7F7F7F;font-size:16px">锦园学校收费系统</div>
            </div>
            <div style="padding:10px;width:80%;margin-left:10%;margin-top:10px;background-color:#FFF">
                <mu-text-field v-model="selectSchools.text" placeholder="请选择学校" :readonly="true" color="#4935ae" @click="show=true"  icon=":icon icon-xuexiao" >
                </mu-text-field>
            </div>
            <div style="padding:10px;width:80%;margin-left:10%;background-color:#FFF">
                <mu-text-field v-model="selectBanji.name" placeholder="请选择班级" :readonly="true" color="#4935ae" @click="showBanjiFun"  icon=":icon icon-jiaoshi_banji" >
                </mu-text-field>
            </div>
            <div style="padding:10px;width:80%;margin-left:10%;background-color:#FFF">
                <mu-text-field v-model="name" placeholder="请输入姓名" color="#4935ae" icon=":icon icon-xingming" ></mu-text-field>
            </div>
            <!-- <div style="padding:10px;width:80%;margin-left:10%;background-color:#FFF">
                <mu-text-field v-model="selectSex" placeholder="请选择性别" :readonly="true" color="#4935ae" @click="showSex=true"  icon=":icon icon-tongxingbie" >
                </mu-text-field>
            </div> -->
            <div style="padding:10px;width:80%;margin-left:10%;background-color:#FFF">
                <mu-text-field v-model="phone" placeholder="请输入手机号" color="#4935ae" icon=":icon icon-shoujihao" ></mu-text-field>
            </div>
            <div style="padding:10px;text-align:center;background-color:#FFF;margin-top:10px">
                <div class="button" @click="login">
                    <span><i class="icon iconyanzheng" style="color: #eee;font-weight: 500;padding-right: 15px;font-size:20px;"></i>&nbsp;&nbsp;</span>
                    <span style="color: #FFF;font-weight: 500;font-size: 17px;">登录</span>
                </div>
            </div>
        </div>
        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
            <van-picker
                title="请选择学校"
                show-toolbar
                :columns="schools"
                value-key="text"
                @confirm="onConfirm"
                @cancel="show = false"
            />
        </van-popup>
        <van-popup v-model="showBanji" position="bottom" :style="{ height: '40%' }">
            <van-picker
                title="请选择班级"
                show-toolbar
                :columns="banjiList"
                value-key="name"
                @confirm="onConfirmBanji"
                @cancel="showBanji = false"
            />
        </van-popup>
        <van-popup v-model="showSex" position="bottom" :style="{ height: '40%' }">
            <van-picker
                title="请选择性别"
                show-toolbar
                :columns="['男','女']"
                value-key="text"
                @confirm="onConfirmSex"
                @cancel="showSex = false"
            />
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    data(){
        return {
            account:'',
            phone:'',
            visibility:false,
            initData:JSON.parse(window.localStorage.getItem("account")),
            name:'',
            selectSchools:{},
            selectBanji:{},
            selectSex:'',
            banjiList:[],
            show:false,
            showBanji:false,
            showSex:false,
            schools:[]

        }
    },
    created(){
        if(window.localStorage.getItem("token")){
            this.router.replace({path:'/tabs'})
        }
        this.$request.get("students/getSchools").then(data=>{
            if(data.status==200){
                this.schools=data.content
            }
        })
    },
    methods:{
        goRegist(){
            this.router.push({path:'/regist'})
        },
        onConfirm(value) {
            this.selectSchools = value;
            this.selectBanji = {}
            this.show = false;
            this.getBanji()
        },
        onConfirmBanji(value) {
            this.selectBanji = value;
            this.showBanji = false;
        },
        onConfirmSex(value){
            this.selectSex = value;
            this.showSex = false;
        },
        showBanjiFun(){
            if(!this.selectSchools.id){
                this.$toast.fail("请先选择学校")
                return;
            }
            this.showBanji=true
        },
        getBanji(){
            this.$request.get("students/getClassNames",{schoolId:this.selectSchools.id}).then(data=>{
                if(data.status==200){
                    this.banjiList=data.content
                }
            })
        },
        login(){
            if(!this.selectSchools.id){
                Toast.fail("请选择学校")
                return;
            }
            if(!this.selectBanji.id){
                Toast.fail("请选择班级")
                return;
            }
            if(!this.name){
                Toast.fail("请输入姓名")
                return;
            }
            // if(!this.selectSex){
            //     Toast.fail("请输入性别")
            //     return;
            // }
            if(!this.phone){
                Toast.fail("请输入手机号")
                return;
            }else{
                var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!myreg.test(this.phone)) {
                    Toast.fail("请填写正确的手机号码")
                    return false;
                }
            }
            const toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '登陆中...',
            });
            this.$request.post("students/signin",{
                schoolId:this.selectSchools.id,
                classId:this.selectBanji.id,
                name:this.name,
                phone:this.phone,
                gender:this.selectSex
            }).then(data=>{
                Toast.clear();
                if(data.status==200){
                    window.localStorage.setItem("token", data.content.token)
                    window.localStorage.setItem("user", JSON.stringify(data.content.user))
                    this.router.replace({path:'/tabs'})
                }else{
                    Toast.fail(data.message);
                }
            }).catch((err)=>{
                Toast.clear();
                Toast.fail(err.message);
            })
        }
    }
}
</script>

<style>
    .button{
        background-color: #4935ae;
        display: flex;
        align-items: center;
        height:46px;
        justify-content: center;
        padding: 4px 24px;
        width: 80%;
        margin-left: 10%;
        border-radius: 5px;
    }
    .bottm{
        width: 100%;
        position: absolute;
        z-index: -1;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 0px;
        left: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/Login.vue